import { Component, Inject, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import {
  Treatment,
  TreatmentsService
} from 'src/app/core/remote-json/treatments/treatments.service';
import { RecommendationTemplate } from './recommendation-template.model';

export interface AttachTemplateModalData {
  templateKey: string;
  template: RecommendationTemplate;
}

export interface AttachTemplateModalResult {
  exercises: string[];
  otcEyeDrops: string[];
  rxEyeDrops: string[];
  procedures: string[];
}

@Component({
  selector: 'csi-attach-template-modal',
  templateUrl: './attach-template-modal.component.html',
  styleUrls: ['./attach-template-modal.component.scss']
})
export class AttachTemplateModalComponent implements OnInit {
  isAiLoading = true;

  exercisesControl = new FormControl([]);
  otcControl = new FormControl([]);
  rxControl = new FormControl([]);
  proceduresControl = new FormControl([]);

  constructor(
    private treatmentsService: TreatmentsService,
    private dialogRef: MatDialogRef<AttachTemplateModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: AttachTemplateModalData
  ) {}

  ngOnInit(): void {
    this.exercisesControl.setValue(this.toTreatments(this.data.template.exercises));
    this.otcControl.setValue(this.toTreatments(this.data.template.otcEyeDrops));
    this.rxControl.setValue(this.toTreatments(this.data.template.rxEyeDrops));
    this.proceduresControl.setValue(this.toTreatments(this.data.template.procedures));

    setTimeout(() => (this.isAiLoading = false), 900);
  }

  cancel(): void {
    this.dialogRef.close(false);
  }

  attach(): void {
    const result: AttachTemplateModalResult = {
      exercises: this.toIds(this.exercisesControl.value),
      otcEyeDrops: this.toIds(this.otcControl.value),
      rxEyeDrops: this.toIds(this.rxControl.value),
      procedures: this.toIds(this.proceduresControl.value)
    };

    this.dialogRef.close(result);
  }

  private toTreatments(ids: string[] | undefined): Treatment[] {
    return (ids || [])
      .map(id => this.treatmentsService.idToTreatmentMap.get(id))
      .filter((t): t is Treatment => !!t);
  }

  private toIds(items: any): string[] {
    return (items || []).map((t: Treatment) => t && t.id).filter((id: string) => !!id);
  }
}
